@if (options() && options().length > 0) {
<section class="relative flex w-full overflow-y-visible border-base-300" [class.overflow-x-auto]="scrollEnabled()">
    @for (option of options(); track $index) {
    <div
        segmentOption
        #item
        (click)="handleClick(option)"
        [active]="value() === option.value"
        [option]="option"
        [color]="color()"
    ></div>
    }
    <div
        #indicator
        [attr.data-color]="color()"
        class="absolute transition-all duration-300 ease-in-out indicator"
        style="height: 0.15rem"
        [style.bottom]="scrollEnabled() ? 0 : '-0.15rem'"
    ></div>
</section>
}
